export class PipelineSection {
  public pipelineSectionId: number;
  public name: string;
  public diameter: number;
  public trackingFileName: string;
  public trackingFile: string;

  public constructor(
    pipelineSectionId: number,
    name: string,
    diameter: number,
    trackingFileName: string,
    trackingFile: string
  ) {
    this.pipelineSectionId = pipelineSectionId;
    this.name = name;
    this.diameter = diameter;
    this.trackingFileName = trackingFileName;
    this.trackingFile = trackingFile;
  }
}
